import React, { FC } from "react";

import { Chip, ChipProps } from "@mui/material";
import { styled } from "@mui/material/styles";

import { DISABLED, ERROR, INFO, MIXED_ERROR, SUCCESS, WARNING } from "./theme";

export type ChipStatus =
  | "success"
  | "disabled"
  | "info"
  | "error"
  | "warning"
  | "mixedError";

export interface IgChipProps extends ChipProps {
  status?: ChipStatus;
}

const PREFIX = "IgChip";

const classes = {
  success: `${PREFIX}-success`,
  disabled: `${PREFIX}-disabled`,
  info: `${PREFIX}-info`,
  error: `${PREFIX}-error`,
  mixedError: `${PREFIX}-mixedError`,
  warning: `${PREFIX}-warning`,
};

const StyledChip = styled(Chip)(({ theme }) => ({
  borderRadius: "10px",
  paddingLeft: "4px",
  paddingRight: "4px",
  height: "25px",

  [`&.${classes.success}`]: SUCCESS,
  [`&.${classes.disabled}`]: DISABLED,
  [`&.${classes.info}`]: INFO,
  [`&.${classes.error}`]: ERROR,
  [`&.${classes.warning}`]: WARNING,
  [`&.${classes.mixedError}`]: MIXED_ERROR,
}));

/**
 * @see Chip
 */
export const IgChip: FC<IgChipProps> = (props) => {
  const { children, status, ...rest } = props;

  if (status) {
    return (
      <StyledChip className={classes[status]} {...rest}>
        {children}
      </StyledChip>
    );
  }

  return <StyledChip {...rest}>{children}</StyledChip>;
};
